export const MULTIARRAY_EMAIL_TEMPLATE = {
  to: 'support@multiarray.com',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello MultiArray

Could you please enable Snug as an upload destination for our agency for the MultiArray Account(s):

- [Enter your Agency ID here]

Please assign the MultiArray Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
